















import Vue, { PropType } from 'vue';
import CardLayout from '@/components/card-layout/CardLayout.vue';
import { DreesContacts } from '@/types';
import { getInitials } from '@/util';
import { ContactStatus, TeamGroup } from '@/constants';

export default Vue.extend({
  name: 'DreesTeam',
  components: {
    CardLayout
  },
  props: {
    dreesContacts: {
      type: Array as PropType<DreesContacts[]>,
      required: true
    },
    postClose: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    filteredContacts (): DreesContacts[] {
      return this.dreesContacts.filter((contact: DreesContacts) => this.checkContactDisplay(contact));
    }
  },
  methods: {
    fetchInitials (firstName: string, lastName: string) {
      return getInitials(firstName, lastName);
    },
    checkContactDisplay (contact: DreesContacts): boolean {
      if (contact.teamGroup) {
        return (contact.teamGroup.toLowerCase() !== TeamGroup.CC && contact.status.toLowerCase() === ContactStatus.ACTIVE) || this.postClose;
      }
      return true;
    }
  }
})
